import { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import HeaderSocials from './Header_Partials/HeaderSocials';
import clsx from 'clsx';
import Context from 'root/Context';
import { ControllerContext } from 'components/Controller/Controller';
import { screens } from 'components/sections/constants';
import Icon from 'ui/Icon/Icon';
import ListIcon from 'ui/SVG/ListIcon';
import './Header.scss';

const Header: React.FC = () => {
  const { isMenu, toggleMenu } = useContext(Context);
  const { active, dispatchActive } = useContext(ControllerContext);
  const [nav, setNav] = useState(false);
  useEffect(() => {
    setNav(
      active !== screens.NONE &&
        active !== screens.HERO &&
        active !== screens.SITEMAP
    );
  }, [active]);

  return (
    <header
      className={clsx('header', isMenu && '--menu-active', nav && '--nav')}
    >
      <div className="container header__container">
        <div
          onClick={() => {
            if (active !== screens.HERO) {
              dispatchActive(screens.HERO);
            }
          }}
          className="header__logo"
        >
          <img src={require('images/bitbloom-logo.png')} alt="logo" />
          {/* <p>Samudai</p> */}
        </div>
        <nav className="header__nav">
          <div className="header__nav-btn header__nav-btn_sitemap" />
          {/* <NavLink to="#" onClick={() => dispatchActive(screens.SITEMAP)} className="header__nav-btn header__nav-btn_sitemap">
            <span>Site Map</span>
          </NavLink> */}
          <HeaderSocials active={active} dispatchActive={dispatchActive} />
          <NavLink to="#" className="header__nav-btn">
            <span>About us</span>
          </NavLink>
        </nav>
        <button className="header__btn whitelist-btn">
          <Icon className="whitelist-btn__icon">
            <ListIcon />
          </Icon>
          <p className="whitelist-btn__text">Go to App</p>
        </button>
        <button
          className="header__burgermenu"
          onClick={() => toggleMenu(!isMenu)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
